import { render, staticRenderFns } from "./HighlightedTopic.vue?vue&type=template&id=0c04d63a&"
import script from "./HighlightedTopic.vue?vue&type=script&lang=js&"
export * from "./HighlightedTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c04d63a')) {
      api.createRecord('0c04d63a', component.options)
    } else {
      api.reload('0c04d63a', component.options)
    }
    module.hot.accept("./HighlightedTopic.vue?vue&type=template&id=0c04d63a&", function () {
      api.rerender('0c04d63a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/blocks/HighlightedTopic/HighlightedTopic.vue"
export default component.exports